import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { AiRecommendationFragmentDoc } from '../../../../../../../modules/homepage/views/Homepage/widgets/HomepageAIRecommendationsWidget/graphql/fragments/generated/AiRecommendation';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RecommendedActionsQueryVariables = Types.Exact<{
  recommendationsFilters?: Types.InputMaybe<Types.RecommendedActionsFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RecommendedActionsQuery = { recommendedActions: { totalCount: number, success: boolean, errorCode?: Types.PaginationErrorCodeEnum | null, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, type: Types.RecommendedActionTypeEnum, targetModule: Types.RecommendedActionTargetModuleEnum, status: Types.RecommendedActionStatusEnum, card: { title: string, subTitle: string, reasons: Array<string>, avatar?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, actions?: Array<{ type: Types.RecommendedActionCtaTypeEnum, label: string, identifierId?: string | null, path?: string | null, prefill?: string | null, url?: string | null }> | null } } }> | null } };


export const RecommendedActionsDocument = /*#__PURE__*/ gql`
    query RecommendedActions($recommendationsFilters: RecommendedActionsFilters, $first: Float, $after: String) {
  recommendedActions(
    filters: $recommendationsFilters
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...AiRecommendation
      }
    }
    success
    errorCode
  }
}
    ${AiRecommendationFragmentDoc}
${EntityMediaFragmentDoc}`;

export function useRecommendedActionsQuery(options?: Omit<Urql.UseQueryArgs<RecommendedActionsQueryVariables>, 'query'>) {
  return Urql.useQuery<RecommendedActionsQuery, RecommendedActionsQueryVariables>({ query: RecommendedActionsDocument, ...options });
};